module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch5"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is unnecessary to remind readers of the importance of Romans, but Luther’s oft-quoted tribute in his preface to Romans is still relevant:")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros2"
  }, [_vm._v("This epistle is really the chief part of the New Testament, and is truly the purest gospel. It is worthy not only that every Christian should know it word for word, by heart, but also that he should occupy himself with it every day, as the daily bread of the soul. We can never read it or ponder over it too much; for the more we deal with it, the more precious it becomes and the better it tastes."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-072-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-072"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Origen, however, in his preface to his commentary on Romans, notes that Romans is harder to understand than all of Paul’s other letters and stirs up questions that the heretics distort ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. Rom.")]), _vm._v("). Nevertheless, Romans has had an enormous impact on the lives of many (Augustine, Luther, Wesley and Barth) who in turn influenced Christian history. John Chrysostom ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 350–407), a prolific commentator on Paul’s letters, exuberantly praises him in seven homilies ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De laudibus sancti Pauli apostoli   ")]), _vm._v(") that express his profound love for Paul."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-071-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-071"
    }
  }, [_vm._v("2")])])]), _vm._v(" Paul receives less than glowing appraisals among some modern laity and scholars. Talbert summarizes these critiques and rightly concludes, ‘A fresh reading of this seminal document holds the promise of life’ (Talbert, p. 5). A ‘fresh reading’ is what Luther did. He initially ‘hated Paul’ with all his heart because when he read in 1:17 that the righteousness of God is revealed in the gospel he thought that ‘this righteousness was an avenging anger, namely, the wrath of God’ that would punish him for his sins. But later he said,")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros2"
  }, [_vm._v("At last, by the mercy of God, meditating day and night, I gave heed to the context of the words, namely, ‘In it the righteousness of God is revealed, as it is written, “He who through faith is righteous shall live.”’ There I began to understand that the righteousness of God is that by which the righteous lives by a gift of God, namely by faith . . . Here I felt that I was altogether born again and had entered paradise itself through open gates. There a totally other face of the entire Scripture showed itself to me."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-070-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-070"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A fresh reading need not entail discarding older interpretations as necessarily inferior because they come from an earlier era. The gadflies of Athens were guilty of the logical fallacy of the appeal to novelty (Acts 17:21), which assumes something is better simply because it is innovative and seemingly more relevant.")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch6"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1. The audience of the letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When Paul wrote this letter, the city of Rome was the capital of the Mediterranean world, and Nero had become emperor at the age of sixteen in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 54. With Nero being guided by advisors such as Seneca, his tutor, most were hopeful that Nero’s rule would bring peace. Rome was certainly the foremost place in the empire to receive Paul’s reflection on his gospel, but the destination of this letter is tied to his apostolic calling that drives his planned trips to Jerusalem, Rome and then Spain. The letter assumes that a Christian community is firmly established in Rome since Paul has for many years wanted to come to them and their faith is renowned throughout the world (1:8). He is mindful that he did not found this community. They have been obedient ‘to the form of teaching to which you were entrusted’ (6:17) that came not from Paul but from others. Therefore, he cannot say that they have obeyed him, as he says the Philippians have (Phil. 2:12). He also cannot call them his ‘beloved children’ (1 Cor. 4:14; 2 Cor. 12:14; Gal. 4:19; 1 Thess. 2:7, 11) or expect them to imitate him, as he expects the churches he evangelized to do (1 Cor. 4:16–17; 11:1; Phil. 3:17; 4:9; 1 Thess. 1:6; 2 Thess. 3:6–9). His frequent resort to the diatribe style in this letter in which he answers an imaginary interlocutor to make his points (2:1–5, 17–24; 9:19–21; 11:17–24; 14:4, 10) and to respond to objections and false conclusions (3:1–9; 3:31 – 4:2a; 6:1–3, 15–16; 7:7, 13–14; 9:14–15, 19–20) ‘is particularly appropriate in a letter to a church which he does not know, for elsewhere he can argue directly with his readers’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-069-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-069"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It is unknown when or by whom the faith communities in the city of Rome were founded, but the church was not established by Peter as the later legend has it. Neither Acts nor Paul makes any mention of Peter (or any other apostle) having any connection to Rome. Luke does assert that ‘visitors from Rome’ were present in Jerusalem during Pentecost (Acts 2:10). It is likely that some of them were converted by the disciples’ preaching, particularly that of Peter (Acts 2:14–40), and shared the gospel when they returned to Rome. Anonymous Christian merchants and business people such as Aquila and Prisca also would have brought the gospel. Perhaps Sergius Paulus, the proconsul of Cyprus who heard the word of God from Paul and Barnabas and believed (Acts 13:6–12), was another example of those who spread the gospel upon their return to the city. The community of faith that had Jewish origins swelled with Gentile converts. Tacitus describes Nero unleashing a ferocious persecution of Christians to shift blame onto them for the massive fire that consumed Rome in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 64. He says that a vast multitude was convicted ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann.")]), _vm._v(" 15.44). This note, even if an exaggeration, suggests that the believers had experienced a marked growth in numbers, which had caught the unwanted attention of the authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul does not address them as ‘the church’ in Rome (cf. 1 Cor. 1:2; 2 Cor. 1:1; 1 Thess. 1:1) but as ‘all God’s beloved in Rome, who are called to be saints’ (1:7). One can infer that the Roman Christians did not meet together as one gathering but in a number of different house churches distributed throughout the various quarters of the city. Paul greets five separate households (16:5, 10, 11, 14, 15) where believers gathered, and there may have been more. Scholars disagree as to whether the primary audience was composed of Jewish or Gentile Christians. The disagreements in interpreting the data suggest that Paul viewed his audience as mixed. He assumes that they know the Old Testament. He mentions Adam, Abraham, Sarah, Isaac, Rebecca, Esau, Jacob, Pharaoh, Moses, Elijah, David and Zion without clarifications. He includes frequent citations of or allusions to the Hebrew Scriptures in their Greek translation ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("LXX")]), _vm._v("). He addresses Jews by referring to Abraham as ‘our ancestor according to the flesh’ (4:1) and when he says ‘I am speaking to those who know the law’ in 7:1. Specific references to the Gentiles/nations ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ethnē  ")]), _vm._v(") appear twenty-nine times in the letter, and he addresses them directly in 11:13: ‘Now I am speaking to you Gentiles.’ This phrase that singles out Gentiles to take notice implies that Paul does not think that he has been addressing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only")]), _vm._v(" Gentiles previously. Paul maintains that ‘all have sinned’ (3:23), that Christ’s ‘act of righteousness leads to justification and life for all’ (5:18), that God ‘did not withhold his own Son, but gave him up for all of us’ (8:32) so that God might ‘be merciful to all’ (11:32) and ‘all the peoples’ might ‘praise him’ (15:11). It is reasonable to conclude that Romans is not aimed at a particular ethnic group in a community of faith but is concerned with the church universal composed of Jews and Gentiles.")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd",
    attrs: {
      "id": "rch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2. Date and provenance")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Paul states that he has completed his missionary work among the eastern part of the Roman Empire from Jerusalem to Illyricum (15:19, 23) and writes this letter prior to his journey to Jerusalem with the collection for the poor among the saints there (15:25–26). The scenario in Acts fits this setting. After Paul’s relatively long ministry in Ephesus, probably from "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 52 to 54, Acts 20:1–3 records Paul journeying through the regions of Macedonia and coming to Greece, where he stayed three months before embarking for Syria, which may include a reference to Jerusalem since it was a Roman territory attached to the province of Syria. To avoid a Jewish plot against him, he instead went back through Macedonia. Acts identifies his travel companions as Sopater from Beroea, Aristarchus and Secundus from Thessalonica, Gaius from Derbe, and Timothy, Tychicus and Trophimus from Asia (Acts 20:4). They are presumably representatives from the churches who contributed to the collection for Jerusalem and who will accompany him there. Paul probably wrote this letter in Corinth, the capital of Achaia. He commends Phoebe, a Christian deacon from the church in Cenchreae, the eastern seaport of Corinth, who almost certainly delivers the letter (16:1–2). He also sends greetings from Gaius, one of his early converts in Corinth (1 Cor. 1:14), who Paul says is host to him and to the whole church (16:23). Erastus, who sends greetings, is probably the same person identified in a Latin inscription in Corinth from the mid first century: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ERASTVS. PRO. AED. S. P. STRAVIT")]), _vm._v(" (‘Erastus, in return for his aedileship, laid [the pavement] at his own expense’; cf. the comments on 16:23).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Dates are difficult to pin down precisely, and the time frame for when Romans was written is based on the dating of Paul’s en-counter with Gallio, the brother of Seneca and the proconsul of Achaia (Acts 18:12–17). An inscription found at Delphi ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SIG")]), _vm._v(" II, p. 801) shows that Gallio was proconsul of Achaia in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 52. Paul probably was brought before Gallio early in the latter’s governorship since the Jews would have been attempting to win a new governor to their side, which would have been from mid 51 to mid 52. The proposals for when Paul wrote Romans vary. Some contend that Paul wrote during the winter of "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 56/57 (Jewett, Moo, Schnabel); others contend that he composed the letter in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 55/56 (Cranfield, Dunn).")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd",
    attrs: {
      "id": "rch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3. The integrity of the letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The arguments so far assume the integrity of the letter. The differing placements in the manuscript tradition of the doxology in 16:25–27 that marks the end of the letter raise questions. The majority of the earliest and most reliable copies of Romans place it at the end of the letter."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-068-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-068"
    }
  }, [_vm._v("5")])])]), _vm._v(" Some manuscripts place the doxology at the end of chapter 14. Papyrus 46, a valuable, slightly mutilated collection of Pauline epistles that dates from between "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 175 and 225, places the doxology between 15:33 and 16:1. No extant Greek manuscript of Romans omits 15:1 – 16:23, but scholars have offered various theories to explain the differing locations of the doxology in 16:25–27.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Origen claimed that Marcion expunged this doxology and cut out everything after 14:23 resulting in a fourteen-chapter version of Romans."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-067-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-067"
    }
  }, [_vm._v("6")])])]), _vm._v(" One might guess that Marcion was less than pleased with Paul’s assertions that the Old Testament Scriptures were ‘written for our instruction’ (15:4) and that ‘Christ has become a servant of the circumcised on behalf of the truth of God in order that he might confirm the promises given to the patriarchs’ (15:8). Later scholars theorize that Paul made two copies of the letter, one without chapter 16 that he sent to the Romans, and one that added the greetings in chapter 16 that he sent to Ephesus. Others contend that chapter 16 was a separate letter sent originally to Ephesus that for some reason was appended to Romans. Ephesus becomes the primary nominee as a possible recipient of this hypothetical letter because of the mention of Prisca and Aquila (16:3–4) who had lived there (Acts 18:19) and the identification of Epaenetus as the first convert of Asia (16:5), the name of the Roman province in which Ephesus was located.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("No extant manuscript of Romans, however, contains any reference to Ephesus, and the Ephesian theories have not won the day. Prisca and Aquila may have returned to Rome, where they still had business connections and could have maintained their residence during their exile. Paul does not send personal greetings to individuals in his letters to the churches where he had lived and worked for some time. Why risk omitting someone’s name and hurting feelings? The Ephesians also would not need to be informed that Prisca and Aquila risked their lives for Paul (16:4) or that Epaenetus was the first convert. Those details are more likely included for the benefit of those outside Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("No Romans manuscript ends with chapter 15, which clearly is intended for Rome (15:22–29), and its concluding phrase, ‘The God of peace be with all of you. Amen’ (15:33), is not Paul’s normal way of terminating a letter (cf. 16:20; 2 Cor. 13:11; Phil. 4:9; 1 Thess. 5:23; 2 Thess. 3:16). It is implausible that chapter 16 was an independent letter to commend Phoebe that is composed mostly of greetings. An important word that modern translations often do not translate is the Greek word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de ")]), _vm._v("(‘and’ [or ‘now’]) in the opening phrase of 16:1. When it is translated ‘Now I commend to you Phoebe’, it suggests a continuation of the letter rather than the beginning of a new one. It is also hard to explain why anyone would have wanted to remove the prescript and the normal thanksgiving section of this imagined letter that commended Phoebe to the Ephesians and attach it to Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The unusually long list of greetings in 16:3–16 is best explained by the unusual circumstances of his letter to the Romans. Since Paul has never visited Rome, it is more likely that he would want to boost his standing among the Romans and their receptiveness to his gospel by associating himself with a sizeable number of people whom they know and respect. The persons Paul lauds in this list can serve as his character references. They would also be likely to endorse his planned missionary enterprise to Spain and encourage others to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("One might ask how Paul knows so many in a place he has never visited. Only five of the names are clearly Jewish, so it does not seem to be the case that these are persons formerly exiled from Rome by Claudius who have now returned with the reign of Nero (see below). Christians travelled widely, which is why hospitality was high on the list of Christian virtues. We might assume that Paul encountered these persons in his and their many travels.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("While it is possible that Marcion caused the manuscript confusion, the most likely explanation for the possible shortened form of Romans was a later desire to abbreviate the letter to make it more universal."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-066-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-066"
    }
  }, [_vm._v("7")])])]), _vm._v(" This wish for a more generic version of Romans relevant for any Christian community is intimated by the omission of the phrase ‘in Rome’ in 1:7 in some Latin versions."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-065-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-065"
    }
  }, [_vm._v("8")])])]), _vm._v(" If the phrase was deliberately deleted, it may also be connected to the abridged edition of Romans that omitted 15:1 – 16:23. The conclusion that Romans was originally sixteen chapters appropriately remains the predominant view.")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd",
    attrs: {
      "id": "rch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4. The occasion for the letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Romans contains the reflections of one who has hammered out his theology in proclaiming the gospel in the eastern part of the Graeco-Roman world in synagogues (Acts 9:20; 13:5, 14, 43–44; 14:1; 17:1–2, 10, 17; 18:19; 19:8), marketplaces (Acts 17:17), lecture halls (Acts 19:9–10) and house church gatherings (Acts 18:7). He says that he laid out the gospel he proclaimed among the Gentiles before the pillar apostles in Jerusalem (Gal. 2:2), not to have them check it out but to try to stop interlopers from going out from Jerusalem and insisting that circumcision was a requirement for salvation (Acts 15:1; Gal. 2:12). Paul received his understanding of the gospel he preached ‘through a revelation of Jesus Christ’ (Gal. 1:11–12) and would not compromise or concede any of its fundamentals ‘so that the truth of the gospel might always remain"), _c('em', {
    staticClass: "italic"
  }), _vm._v("with’ the churches he had founded (Gal. 2:5, 14). Romans contains key elements of that gospel, and Luther went so far as to assert that Paul ‘wanted in this one epistle to sum up briefly the whole Christian and evangelical doctrine and to prepare an introduction to the entire Old Testament’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-064-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-064"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("While many still consider Romans to be, as Beker describes it, ‘a well-ordered theological composition’ and ‘in some sense a “dogmatics in outline”’,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-063-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-063"
    }
  }, [_vm._v("10")])])]), _vm._v(" most now regard it to be a genuine letter that addresses particular circumstances."), _c('sup', {
    staticClass: "sup"
  }), _vm._v("The particular circumstances that prompted Paul to write this letter have sparked much debate. Why is the letter so unlike his earlier correspondence with the Thessalonians, Galatians and Corinthians, having the character of a summary of his teaching? Many passages take up and develop thoughts and motifs that Paul had already used in his earlier letters (Lohse, p. 46). Why did Paul think an extended presentation of his gospel was necessary? Did he write to address problems related to the recipients’ circumstances, as he does in other letters, or is Romans unique in that Paul’s own circumstances prompted this letter?")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Jervis sorts the main proposals as to the purpose of Romans into three categories: ‘theological’, ‘missionary’ and ‘pastoral’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-062-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-062"
    }
  }, [_vm._v("11")])])]), _vm._v(" Since we learn more about Paul’s circumstances as apostle to the Gentiles and little about how things stand with the Roman house churches, the description of his plans regarding trips to Rome, Jerusalem and Spain most likely convey the purposes behind the letter. Paul normally writes in lieu of a visit "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("after")]), _vm._v(" he has been with a church. Romans is written in preparation for a visit to a group of believers he mostly has never met, and Paul declares three times that he hopes finally to make his long-desired visit to Rome (1:10, 11, 13). It is more likely, then, that his purposes in writing primarily relate to his aspiration to create a base from which to extend his proclamation of the gospel beyond Rome. Paul does not seek to intervene in any imagined problems in the Roman faith community, except, perhaps, for 14:1 – 15:13. Instead, he offers a theological résumé that will encourage them to support his mission further west. He lays out ethical guidelines that not only would pre-empt problems that have arisen in his churches in the East but that also remain valid for all believers struggling to live out God’s reconciliation in their communal life and in a pagan society. In my view, Dahl is right:")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros1"
  }, [_vm._v("It is not the problems of a local church but the universal gospel and Paul’s own mission which in this letter provide the point of departure for theological discussion. This is made very clear by the way in which Paul introduces the theme of the letter [1:8–15, 16–17]."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-061-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-061"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("a. The frame of the letter as the key for unlocking the purposes of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Since Paul’s practice is to express his most important concerns in the opening and closing remarks that encase a letter, his comments in 1:1–17 and 15:14–33 provide the most important clues for understanding the letter’s purposes."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-060-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-060"
    }
  }, [_vm._v("13")])])]), _vm._v(" In this frame, Paul reveals more about his own situation and apostolic commission to preach the gospel among the Gentiles and to bring about their obedience of faith (1:5; 15:28) than in any other letter. ‘I’ predominates in both sections as he focuses on himself and his plans.")]), _vm._v(" "), _c('h2', {
    staticClass: "chd"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("i. The letter’s opening (1:1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The salutation in 1:1–7 is notable for being about ten times longer than his other letter openings, and ‘no other known ancient letter from the Graeco-Roman or traditionally Jewish environment contains such an extensive letter opening’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-059-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-059"
    }
  }, [_vm._v("14")])])]), _vm._v(" Verses 1 and 7 would comprise the usual greeting of a Hellenistic letter that consisted of the sender, the recipients and a greeting (cf. Acts 23:26; 1 Thess. 1:1). Though Paul identifies Timothy as the co-sender in other letters (2 Cor. 1:1; Phil. 1:1; Col. 1:1; 1 Thess. 1:1; 2 Thess. 1:1; Phlm. 1), he is mentioned only as his co-worker who sends greetings in 16:21 and not as the co-sender of Romans. The focus falls solely on Paul, who introduces himself with three distinctions – ‘slave of Jesus Christ’ ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("NRSV")]), _vm._v(" mg.), ‘called to be an apostle’, ‘set apart for the gospel of God’ (1:1) – instead of the usual one in his address to churches who know him well. He expands the prescript in 1:2–4 by utilizing what many assume to be confessional material to sum up his gospel. He emphasizes his divine calling, having received from God the grace of apostleship (implied by the passive voice) ‘to bring about the obedience of faith among all the Gentiles for the sake of his name’. He notes that the Romans also fall into this orbit, ‘including yourselves’ (1:6), which can warrant his boldness (15:15) in writing to them. His description of the recipients in 1:7 is cordial but not intimate. They are ‘all God’s beloved in Rome, who are called to be saints’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul’s thanksgiving for the Romans also varies from that in his other letters to churches he has founded. ‘Because your faith is proclaimed throughout the world’ (1:8) could apply to many Christian groups. After mentioning his unceasing prayers for them, he centres on his long-cherished hope of coming to Rome that so far has been impeded (1:9–15). Paul’s vagueness about having wanted to share with them ‘some spiritual gift to strengthen you’ and his qualification ‘or rather so that we may be mutually encouraged by each other’s faith, both yours and mine’ (1:11–12) reflect his decision not to appear overbearing but also his lack of intimate familiarity with the recipients. Paul next reviews his indebtedness to preach the gospel to Gentiles, ‘both to Greeks and to barbarians, both to the wise and to the foolish’ (1:14–15), and concludes in 1:16–17 with another summary of the gospel he preaches that serves as the letter’s theme statement (1:16–17). The thanksgiving section diplomatically reveals that he has not purposefully neglected them, and intimates that a primary purpose behind the letter is to pave the way for a future visit as part of his apostolic mandate to preach the gospel to the Gentiles.")]), _vm._v(" "), _c('h2', {
    staticClass: "chd"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ii. The letter’s closing (15:14–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Paul takes up his desire to come to Rome again in 15:14–33 and is more specific in outlining his current plans. The parallels with 1:1–15 are noteworthy:")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list-t"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("1."), _c('span', {
    staticClass: "nl"
  }), _vm._v("The grace of apostleship given to him (1:5; 15:15–16);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("2."), _c('span', {
    staticClass: "nl"
  }), _vm._v("Obedience of faith among all the Gentiles (1:5; 15:18);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("3."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" The universal, impartial extent of salvation (1:5, 14–15; 15:19–24);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("4."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" His service to God described using verbs ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("latreuein/hierougein")]), _vm._v(") and a noun ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("leitourgos")]), _vm._v(") that are related to priestly service (1:9a; 15:16);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("5."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" Offering prayers for one another (1:9b–10; 15:30);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("6."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" The hindrances that have prevented him from coming to Rome (1:13; 15:22);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("7."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" Reliance on God’s will for him to succeed in coming to Rome (1:10; 15:32);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("8."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" The anticipation of mutual encouragement/refreshment when he comes (1:11–12; 15:29, 32);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("9."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" Proclaiming the gospel to the Gentiles (unbelievers; 1:13; 15:18–20);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_vm._v("10."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" Indebtedness to others: Paul, a debtor to Gentiles (1:14); Gentile believers, debtors to the Jerusalem church (15:27);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list"
  }, [_vm._v("11."), _c('span', {
    staticClass: "nl"
  }), _vm._v(" A reference to ‘fruit’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("karpos")]), _vm._v("), reaping ‘fruit’ ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("NRSV")]), _vm._v(" ‘harvest’) among the Romans (1:13), presenting (‘sealing’) the ‘fruit’ of his ministry among the Gentiles to the church in Jerusalem (15:28);")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-list-b"
  }, [_vm._v("12."), _c('span', {
    staticClass: "nl"
  }), _vm._v("Peace (1:7; 15:33).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("An apparent contradiction surfaces between his statements in 1:15, ‘hence my eagerness to proclaim the gospel to you also who are in Rome’, and in 15:20, ‘I make it my ambition to proclaim the good news, not where Christ has already been named, so that I do not build on someone else’s foundation.’ The latter statement speaks of his pioneer evangelism and church planting. He has no intention of planting churches where others already exist (15:18–22; cf. 2 Cor. 10:15–16). He does not mean that he will never proclaim or explain the gospel in cities in which churches planted by others already exist. He understands preaching the gospel more generally here. While Rome fits well the transnational scope of Paul’s calling as apostle to the Gentiles, with its mingling of nationalities from all over the world,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-058-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-058"
    }
  }, [_vm._v("15")])])]), _vm._v(" and he is ever ready to evangelize unbelievers and to instruct believers, he has no intention of settling down in Rome and becoming their resident apostle. His statement in 1:12 perhaps should be translated ‘to be mutually encouraged by our faith in [faithfulness towards] one another’. ‘Faith’ in this instance refers to ‘trust or reliability in a business partnership’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-057-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-057"
    }
  }, [_vm._v("16")])])]), _vm._v(" His goal is not to evangelize Rome but to form a partnership with the Roman Christ-followers that will yield a harvest of converts in climes further west. Paul, however, diplomatically does not disclose until the letter’s closing that his objective is for them to send him on to preach in Spain (15:24).")]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("b. The Romans’ circumstances as the occasion for the letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Donfried insists that the first methodological principle of any study seeking to determine the purposes of Romans ‘should proceed on the initial assumption that this letter was written by Paul to deal with a concrete situation in Rome’. He bases this principle on ‘the fact that every other authentic Pauline writing, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("without exception")]), _vm._v(", is addressed to the specific situations of the churches or persons involved’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-056-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-056"
    }
  }, [_vm._v("17")])])]), _vm._v(" The problem Romans presents is that it is not like every other letter, and the evidence of the specific situation of the church is ‘tantalizingly scanty’, to use Wedderburn’s phrase."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-055-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-055"
    }
  }, [_vm._v("18")])])]), _vm._v(" The tantalizing part invites interpreters to fill in what is scanty with imaginative speculation primarily directed by mirror-reading. This approach assumes that Paul always writes in reaction to something in the recipients’ context, and that what he says is a mirror reflection of an issue confronting the church. While mirror-reading can help clarify a text, it can also be misused to patch holes in theories spun from gossamer-thin evidence. An obvious hazard exists in correlating every imperative, every admonition, every warning and every positive teaching in a letter to a community’s particular situation. Attempts to construe the purpose of Paul’s letter from the imagined circumstances of the Romans are particularly prone to error. Nevertheless, Paul’s lengthy admonition in 14:1 – 15:13 for the strong to practise tolerance towards the weak is the usual starting point for conjectures about the situation in Rome that Paul supposedly addresses. The primary problem with this approach is the circular nature of the argument."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-054-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-054"
    }
  }, [_vm._v("19")])])]), _vm._v(" Interpreters construct a hypothetical setting and then interpret the text to match that life setting."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-053-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-053"
    }
  }, [_vm._v("20")])])]), _vm._v(" Minear reflects an extreme example of this method in assuming that several congregations in Rome are ‘separated from each other by sharp mutual suspicions’ and claims that five different factions or theological positions existed."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-052-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-052"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The speculation about the Romans’ circumstances is also based on meagre historical evidence. Wiefel conjectured that the expulsion of the Jews from Rome by the Emperor Claudius because of their riots, in Suetonius’s words, at ‘the instigation of Chrestus’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("impulsore Chresto")]), _vm._v(") in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 49 dramatically affected the character of Christianity in Rome."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-051-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-051"
    }
  }, [_vm._v("22")])])]), _vm._v(" He claims that a community of believers founded by Jews shifted its composition when Gentile converts suddenly became the majority. When the Jews returned to Rome after Claudius’s death, they found themselves relegated to a disenfranchised minority, and the church became ensnared in disputes over the relevance and application of the Jewish law. Wiefel alleges that Paul writes Romans ‘to assist the Gentile Christian majority, who are the primary addressees of the letter, to live together with the Jewish Christians in one congregation, thereby putting an end to their quarrels about status’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-050-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-050"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Barclay dismisses this reconstruction as a ‘tissue of speculation, based on flimsy evidence and ungrounded supposition’ that is ‘best abandoned’. He states,")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros2"
  }, [_vm._v("There is no evidence, either internal or external, that the expulsion of some Jews from Rome in 49 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("CE")]), _vm._v(", or their subsequent return, had any effect on the development of the Christian churches in the city: Paul gives no hint of changes in leadership, in the ethnic composition of the communities, or in relations with synagogues."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-049-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-049"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Claudius did act against the Jews in Rome, as Acts attests. Paul met in Corinth ‘a Jew named Aquila, a native of Pontus, who had recently come from Italy with his wife Priscilla, because Claudius had ordered all Jews to leave Rome’ (Acts 18:2). ‘All Jews’ could be hyperbolic since the entire Jewish population was estimated to be around 40,000–50,000. Dio Cassius ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roman History ")]), _vm._v("60.6.6) reports that Claudius wanted to ban Jews from the city in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 41. No reason is given as to why; one may presume it was because of his fear of religious influences from the East corrupting Roman religious practices. Claudius did not follow through with this because the Jews had grown in such numbers that expelling them would have caused a tumult. Instead, he forbade them from assembling. Suetonius’s reference raises these questions: ‘How many and which Jews did Claudius expel? In what year did the expulsions occur? Who was this Chrestus, and what were the controversies surrounding him?’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-048-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-048"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It is most likely that the expulsion of Aquila and Prisca occurred in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 49, and that it was set off by intra-Jewish turbulence over Jewish Christians preaching Christ to their fellow Jews."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-047-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-047"
    }
  }, [_vm._v("26")])])]), _vm._v(" From archaeological evidence, however, Keener concludes,")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros2"
  }, [_vm._v("It is hard to imagine that the Jewish sections (known from archaeology) remained deserted after their absence; yet it is even more inconceivable that Jews recovered their property after returning if it had been seized by others; therefore it is unlikely that all would have left, despite the edict."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-046-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-046"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is possible to construe Suetonius’s statement to mean that Claudius expelled only those who were causing habitual disturbances or perhaps only ‘the key leaders’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-045-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-045"
    }
  }, [_vm._v("28")])])]), _vm._v(" How many is unclear, but Luke indicates it was a large number. When Claudius died, his stepson Nero ignored many of his decrees as ludicrous (Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nero")]), _vm._v(" 33.1). Many Jews could then return to Rome, which may explain Prisca and Aquila’s presence there (16:3–5). Did all this turmoil reshape the ethnic make-up of the Christian community in Rome in the late 50s when Paul writes?")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul’s exhortations in 14:1 – 15:13 do not provide clear-cut data for identifying the weak and the strong. Some think Paul refers to Jewish and Gentile believers; some, Gentile believers and Jews; and some, only Gentiles. Theories about the occasion of the letter based on the identity of the weak are on shaky ground. Murphy-O’Connor’s analysis of the edict of Claudius leads him to conclude, ‘The Jewish vacuum, which is essential to the theory that the content of Romans was determined by a unique feature of Christianity in the Eternal City, is a myth.’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-044-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-044"
    }
  }, [_vm._v("29")])])]), _vm._v(" Wedderburn’s description of the Romans as embroiled in ‘the maelstrom of the disputes’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-043-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-043"
    }
  }, [_vm._v("30")])])]), _vm._v(" and Wright’s supposition that ‘Christian Gentiles and Christian Jews find themselves in uneasy coexistence’ (Wright, p. 406) seem unjustified. Such bold assertions must assume that Paul’s friends have kept him informed about problems in Rome. Paul, however, makes no mention of having received reports of quarrels or letters raising questions (contrast 1 Cor. 1:11; 7:1; 8:1). This reconstruction of the Roman context flies in the face of Paul’s expression of full confidence in the Roman believers as ‘full of goodness, filled with all knowledge, and able to instruct [admonish] one another’ (15:14). While different evaluations of the rhetoric Paul employs in Romans have reached different conclusions, Wuellner’s contention that the letter affirms ‘the communal values which Paul and the Romans share in being agents of faith throughout the world’, and seeks to increase the strength of their devotion to these values, is on target."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-042-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-042"
    }
  }, [_vm._v("31")])])]), _vm._v(" Paul’s statement that he writes rather boldly ‘to remind’, not to exhort or to correct (15:15),"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-041-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-041"
    }
  }, [_vm._v("32")])])]), _vm._v(" confirms this assessment.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("If 14:1 – 15:13 is not the key for understanding the occasion of this letter, why does Paul include it? Meeks surmises, ‘Paul takes up the topic [of clean and unclean food] out of his experience, not theirs, because it is well suited to show in behavioral terms the outworking of the main theses of the letter.’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-040-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-040"
    }
  }, [_vm._v("33")])])]), _vm._v(" In comparing Philippians with Romans, Hartwig and Theissen make the case that the circumstances of the place where Paul writes made an imprint on the letter. Paul writes from Corinth, and his continuing written and oral interchanges with the Corinthians have been embedded in the letter to the Romans."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-039-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-039"
    }
  }, [_vm._v("34")])])]), _vm._v(" The issue of food offered to idols in 1 Corinthians 8 – 10 is quite different from Paul’s discussion in 14:1 – 15:13."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-038-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-038"
    }
  }, [_vm._v("35")])])]), _vm._v(" To promote unity, Paul extrapolates basic principles from his arguments in 1 Corinthians 8 – 10 and issues commands that are generally applicable to any situation in which humans have diverse views over matters of indifference."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-037-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-037"
    }
  }, [_vm._v("36")])])]), _vm._v(" For Paul, idol food is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" a matter of indifference."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-036-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-036"
    }
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Neither can one infer from Paul’s theological declarations in dialogue with an imagined Jewish opponent (2:17; 3:1–31; 4:1; 7:7, 13; 9:30–32; 11:11) and perhaps with a libertine opponent (6:1, 15) that Paul clashes with challengers in Rome. While similar themes to those in Galatians emerge in Romans, it is misleading to use the conflict in Galatians as a template for interpreting the Romans’ situation. Knox is correct: ‘Romans was written in a quiet and reflective mood; Galatians in the heat of battle.’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-035-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-035"
    }
  }, [_vm._v("38")])])]), _vm._v(" Paul is not engaged in a battle in Romans. It is wrong to interpret his statement that he ‘is not ashamed of the gospel’ to imply that he feels he must defend his gospel from those in Rome who might discredit it. In 1:16–17, Paul is not reacting to some criticism of his gospel but emphasizing that its power does not and will not fail. It has the power to lead both Jew and Greek to salvation, and one’s trust in it will not prove to be in vain (cf. 9:33).")]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("c. Paul’s circumstances as the occasion for the letter")])]), _vm._v(" "), _c('h2', {
    staticClass: "chd1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("i. Taking the gospel to Spain")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Morris asserts that Paul’s statement in 15:14 means that the Roman believers are in good shape. He then asks, if so, ‘why write?’ (Morris, pp. 509–510). When Paul composes Romans, he is poised to embark on a new stage in his apostolic career. He has preached the gospel from Jerusalem to Illyricum (15:19) and avoided building on another’s foundation (15:20). Paul’s focus is on proclaiming the gospel where Christ has not been named in the western perimeter of the empire (15:23–24). Rome is only to be a stopover as he passes through ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("diaporeuomenos")]), _vm._v("). The letter to the Romans is intended to lay the groundwork for his objective to go on to Spain from there with their support."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-034-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-034"
    }
  }, [_vm._v("39")])])]), _vm._v(" This purpose may explain the reference to the ‘barbarians’ as among those to whom Paul believes he is indebted to preach the gospel (1:14). Jewett notes,")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros1"
  }, [_vm._v("Spaniards were viewed as barbarians par excellence because so large a proportion continued to resist Roman rule, to rebel with frightening frequency, and to refuse to speak Latin or to use the Roman names for their cities, streams, or mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros1_pi"
  }, [_vm._v("(Jewett, p. 131)"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-033-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-033"
    }
  }, [_vm._v("40")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This assertion is an overstatement since Seneca the Elder came from Córdoba, Spain, and his sons Gallio, mentioned in Acts 18:12 as the proconsul of Achaia, and Seneca the Younger, who was a well-known Stoic philosopher, statesman, dramatist and Nero’s tutor, were born there but raised in Rome. This general impression of Spaniards as barbarians applies to those residing in Spain and resisting Roman cultural influence.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("We can infer from what Paul writes that his desire to go to Spain would result in bringing in a harvest that would add to ‘the full number of the Gentiles’ (11:25) and would discharge his calling to present them as an offering to God that is ‘acceptable, sanctified by the Holy Spirit’ (15:16). Such a goal tallies with Jesus’ promise to ‘the apostles whom he had chosen’ that when the Holy Spirit comes upon them, they will be witnesses to ‘the ends of the earth’ (Acts 1:2, 8). The city of Gades, modern Cádiz, in Spain was viewed as the end of the earth."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-032-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-032"
    }
  }, [_vm._v("41")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The verb ‘to send on’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("propempein")]), _vm._v(") in 15:24 refers to providing persons to accompany or escort someone on a journey, and to assist in making a journey possible by providing food, money and means of travel."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-031-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-031"
    }
  }, [_vm._v("42")])])]), _vm._v(" Paul needs more than just financial support. The verb signals that he ‘hopes to gain logistical and tactical support from Rome for his mission to Spain’ (Jewett, p. 130). In Spain, for the first time in his ministry Paul ‘would encounter strong linguistic and cultural barriers’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-030-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-030"
    }
  }, [_vm._v("43")])])]), _vm._v(" The Romans could furnish persons to help him navigate these new waters. Prior asserts, ‘Had this mission not been uppermost in his mind, and had he not needed the help of the Romans, he would neither have written to them, nor intended to pass through.’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-029-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-029"
    }
  }, [_vm._v("44")])])]), _vm._v(" Paul uses the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("karpos")]), _vm._v(" (‘fruit’) in 15:28 for the financial offering, which is translated variously as ‘what has been collected’ ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("NRSV")]), _vm._v("), ‘contribution’ ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("NIV")]), _vm._v(") or ‘funds’ ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("CSB")]), _vm._v("), for the Jerusalem saints. He could be making a play on words in 1:13 when he refers to the ‘fruit’, translated as ‘harvest’, that Paul hopes to gain from going to Rome. It may not simply refer to a harvest of converts but could also have a financial connotation. It could refer subtly to his hope that the Romans would provide financial backing for spreading the gospel among the Spaniards in the western reaches of the empire. If so, Paul wants them to take ownership of this mission in the same way that Antioch, under the guidance of the Holy Spirit, had set Paul and Barnabas apart and sent them off to preach the gospel in the West (Acts 13:1–3)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-028-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-028"
    }
  }, [_vm._v("45")])])]), _vm._v(" Later, when churches had been established in Ephesus and Corinth, they served as bases for evangelizing in the provinces of Asia and Achaia. Accordingly, Bruce asks, ‘where would he find a base for the evangelization of Spain if not in Rome?’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-027-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-027"
    }
  }, [_vm._v("46")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul is a good administrator planning diligently ahead (12:8). He")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros2"
  }, [_vm._v("does not wait until he gets to Rome to put this idea in their minds. He is thinking several steps ahead. With this letter to the Christians in Rome, he starts the ball rolling, in order to benefit from its momentum when he arrives."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-026-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-026"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Since Phoebe has helped many, including Paul, in the East (16:1–2), he may be sending her to Rome with the letter to help organize his campaign to the West, which is the ‘matter’ (16:2, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("CSB")]), _vm._v(") he asks them to help her ‘in whatever she may require’ (Jewett, pp. 945–948). Paul would need Rome ‘as at least a springboard if not an operational base for his missionary plans in the West’ (Käsemann, p."), _c('em', {
    staticClass: "italic"
  }), _vm._v("404). He expresses any request for help cautiously and generally because he had no prior relations with the recipients (Schnabel, I, p. 39). He is in no position to make demands as he does of the Corinthians (1 Cor. 16:1–4) but must use discreet diplomacy. He first ‘needs to clarify the theological foundations of his mission before suggesting the nature of the desired cooperation’ (Jewett, p. 130).")]), _vm._v(" "), _c('h2', {
    staticClass: "chd"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ii. The letter as a self-introduction through an introduction to Paul’s gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wedderburn maintains that an adequate explanation of Romans must account for Paul’s impending visits to Jerusalem, Rome and Spain mentioned in the frame of the letter and the detailed exposition of the gospel of God’s righteousness in the body of the letter."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-025-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-025"
    }
  }, [_vm._v("48")])])]), _vm._v(" If preparation for a venture to Spain is a primary purpose behind the writing of this letter, why does Paul include such an extended theological discourse (1:18 – 11:36) as well as the lengthy ethical exhortations (12:1 – 15:13)?")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul must establish a rapport to win their support. In the letter’s frame, he turns his hand to the sensitive task of recommending himself to an audience he has never met."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-024-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-024"
    }
  }, [_vm._v("49")])])]), _vm._v(" He asserts his divine commission as an apostle set apart ‘to bring about the obedience of faith among all the Gentiles for the sake of his name’ (1:1–6; 11:13; 15:15–16). It makes him ‘a debtor both to Greeks and to barbarians, both to the wise and to the foolish’ (1:14). He summarizes the success of his work in the East (15:15–19), and the roll call of twenty-four named persons and two unnamed women whom he asks them to greet (16:3–16) serves, in effect, as a list of those who can vouch for Paul’s trustworthiness and the effectiveness of his gospel."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-023-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-023"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the letter’s central section, Paul presents his gospel that he has preached in the East (cf. Gal. 2:2). He cannot announce his decision to come to Rome and be sent on by them to Spain ‘without further ado’ and ‘assume that they will receive him as [a] legitimate preacher of the gospel or even as an apostle, or that they will forthwith be ready to identify with him and with his evangelistic enterprise in the West’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-022-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-022"
    }
  }, [_vm._v("51")])])]), _vm._v(" He could expect unstinting support for this endeavour"), _c('em', {
    staticClass: "italic"
  }), _vm._v("only"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" after")]), _vm._v(" they have a full grasp of his gospel. He hints that they may have heard defamatory distortions of it (3:8),"), _c('span', {
    staticClass: "bold"
  }), _vm._v("and the body of the letter displays the soundness and authority of his gospel through his interpretation of Scripture (chs. 3–4) and examples from human experience (chs. 5–6). He shows that his gospel was anticipated in the Scripture (1:17; cf. Hab. 2:4) and does not invalidate the law (3:31; 7:12, 14; 10:5–13; 13:8–10) but is its climax (10:4). The believers’ experience of the Holy Spirit further confirms the truth of his gospel (ch. 8). If the letter is a ‘reminder’ (15:15), it also serves as ‘Paul’s calling card’ that he hopes will ensure the Romans’ support for his mission to Spain (15:24) since they ‘will know fully who and what they are supporting’ (Dunn, II, p. 859). Holloway adds that Paul’s adept use of rhetoric presents him as a teacher and ‘person of culture worthy of their sponsorship’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-021-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-021"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "chd"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("iii. The return to Jerusalem weighing on Paul’s mind")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Leenhardt contends, ‘When Paul writes to Rome his mind is full of his Spanish scheme’ (Leenhardt, p. 14). That is not entirely true. Paul’s plans to come to Rome must be postponed once again as he heads east to Jerusalem with the collection (15:25). What awaits him there looms worryingly over him, which might explain other features in the letter’s body.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul mentions the collection for the first time only fleetingly in 1 Corinthians 16:1–4. He is forced to explain its purpose in greater depth in 2 Corinthians 8 – 9 when he needs to bolster the Corinthians’ flagging enthusiasm for the project. Finally, his last mention of the collection occurs in Romans 15:25–28 as he prepares to depart with it for Jerusalem."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-020-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-020"
    }
  }, [_vm._v("53")])])]), _vm._v(" Earlier, the pillar apostles had agreed that God had entrusted him with the gospel for the uncircumcised and was working through him in sending him to the Gentiles (Gal. 2:7–8). Paul reports that they asked only that ‘we remember the poor, which was actually what I was eager to do’ (Gal. 2:10). The collection for ‘the poor among the saints at Jerusalem’ (15:26) may have been a fulfilment of that eagerness. Paul originally thought he would send emissaries from the contributing churches to take the gift to Jerusalem and that he would go only ‘if it seems advisable’ (1 Cor. 16:3–4). Paul now has determined that it is indeed advisable, if not imperative, for him to accompany the emissaries to interpret the gift.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul feels compelled to go in person because, as apostle to the Gentiles, he needs to interpret for the recipients what this gift means theologically about the unity of Jewish and Gentile Christians. Only once does he use the secular business term ‘collection’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("logeia")]), _vm._v(", 1 Cor. 16:1), because it is not simply an offering to help the poor. He primarily refers to it in spiritual terms (author’s translations): ‘grace’, ‘privilege’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("charis")]), _vm._v(", 2 Cor. 8:4, 6, 7, 19); ‘partnership’, ‘sharing’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("koinōnia")]), _vm._v(", Rom. 15:26; 2 Cor. 8:4); ‘service’, ‘ministry’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("diakonia")]), _vm._v(", Rom. 15:25, 31; 2 Cor. 8:4; 9:1, 12, 13); ‘earnestness’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("spoudia")]), _vm._v(", 2 Cor. 8:8); ‘love’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("agapē")]), _vm._v(", 2 Cor. 8:7, 8, 24); ‘willingness’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("promythia")]), _vm._v(", 2 Cor. 8:11, 12, 19; 9:2); ‘generosity’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("haplotēs")]), _vm._v(", 2 Cor. 8:2; 9:11, 13); ‘abundance’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("perisseuma")]), _vm._v(", 2 Cor. 8:14); ‘liberal gift’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hadrotēs")]), _vm._v(", 2 Cor. 8:20); ‘undertaking’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hypostasis")]), _vm._v(", 2 Cor. 9:4); ‘blessing’, ‘generous gift’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eulogia")]), _vm._v(", 2 Cor. 9:5); ‘good work’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ergon agathon")]), _vm._v(", 2 Cor. 9:8); ‘the yield of your righteousness’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ta genēmata tēs dikaiosynēs")]), _vm._v(", 2 Cor. 9:10); ‘[priestly] service’, ‘ministry’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("leitourgia")]), _vm._v(", 2 Cor. 9:12); ‘fruit’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("karpos")]), _vm._v(", Rom. 15:28).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Since Paul did not organize collections for other churches that suffered persecution and poverty, he apparently saw special spiritual significance in this offering for Jerusalem as the culmination of his work in the East."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-019-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-019"
    }
  }, [_vm._v("54")])])]), _vm._v(" By bringing the fruit from the harvest of his proclamation of the gospel among Gentiles back to Jerusalem, Paul reverses the course that took him from Jerusalem around to Illyricum (15:19). He thinks it so important that once again he postpones travelling to Rome and knowingly risks his life (Acts 20:22–24, 36–38; 21:4, 10–14) to deliver and interpret this gift. He envisions it as a concrete symbol that the ‘Christian faith overcomes the deepest racial barriers that formerly separated Jews from Gentiles’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-018-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-018"
    }
  }, [_vm._v("55")])])]), _vm._v(" If successful, the collection manifests that for those who are in Christ the dividing wall of hostility between Jews and Gentiles has been torn down. The two groups have been made one and are united in the bond of peace in Christ Jesus (Eph. 2:14–18). For Paul, it demonstrates that ‘there is one body and one Spirit, just as you were called to the one hope of your calling, one Lord, one faith, one baptism, one God and Father of all, who is above all and through all and in all’ (Eph. 4:4–6)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-017"
    }
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Because Paul is not asking the Romans to contribute to this gift, he does not delve into its theological rationale here as he does in 2 Corinthians 8 – 9. Instead, he makes a striking prayer request:")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros1"
  }, [_vm._v("I appeal to you, brothers and sisters, by our Lord Jesus Christ and by the love of the Spirit, to join me in earnest prayer to God on my behalf, that I may be rescued from the unbelievers in Judea, and that my ministry to Jerusalem may be acceptable to the saints.")]), _vm._v(" "), _c('p', {
    staticClass: "dpy_pros1_pi"
  }, [_vm._v("(15:30–31)"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-016"
    }
  }, [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why ask the Romans to pray that poor people will accept a gift of money?"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-015"
    }
  }, [_vm._v("58")])])]), _vm._v(" What would make this gift unacceptable? The obvious problem was that it was Gentile money. Paul worries that the bitter controversy over the acceptance of uncircumcised Gentiles, ostensibly settled at the Jerusalem conference (Acts 15), continued to endanger the church’s unity. Those who insisted, ‘Unless you are circumcised according to the custom of Moses, you cannot be saved’ (Acts 15:1) and the false brothers he mentions in Galatians 2:4 may still haunt the Jerusalem church. Jewish believers, zealous for the law, might not accept this tangible sign of gratitude because it also entailed accepting Gentiles as their brothers and sisters in Christ, children of Abraham and fellow heirs to the promises to Israel."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-014"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Therefore, it is not surprising that this letter, written on the eve of his departure for Judea, deals with issues that might deter Jewish believers from accepting Gentile believers: the validity of the law for salvation (7:7–25); the justification of humans before God apart from works of the law (3:27 – 4:6; 9:32; 11:6); Abraham as the father of both the circumcised and the uncircumcised who have faith like his (4:12); God’s remedy for the sin of all humans (5:12–21); and the election of Israel and how their hardening in unbelief relates to the inclusion of Gentiles (9:1 – 11:36). These issues addressed in the letter’s central section would be of ‘particular concern to Jerusalem’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-013"
    }
  }, [_vm._v("60")])])]), _vm._v(" Acts records that when Paul arrived in Jerusalem and visited James and the elders, he ‘related one by one the things that God had done among the Gentiles through his ministry’. They responded with praise but expressed apprehension that ‘thousands of believers’ among the Jews who are ‘zealous for the law . . . have been told about you that you teach all the Jews living among the Gentiles to forsake Moses, and that you tell them not to circumcise their children or observe the customs’ (Acts 21:18–21). Paul’s comments about the value of circumcision in 2:25 – 3:2 would be particularly relevant in this context. This context also explains the inclusion of 9:1 – 11:36. Moo asserts, ‘For their part, Jewish Christians need to understand that salvation history has moved on from the days in which God’s people were mainly restricted to Israel’ (Moo, p. 922). Accepting the gift from the Gentile believers would reveal their acceptance of the new situation.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It is too much to say that Romans is ‘a brief drawn up by Paul in anticipation of the renewed necessity of defending his gospel in Jerusalem’,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-012"
    }
  }, [_vm._v("61")])])]), _vm._v(" or that Paul formulates a theological defence of the understanding of the gospel that he will present in Jerusalem when he delivers the collection."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-011-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-011"
    }
  }, [_vm._v("62")])])]), _vm._v(" This letter is not simply a dress rehearsal for Jerusalem. Knowing that he might face challenges when he presents this offering from Gentile Christ-followers may explain why Paul includes so many passages that refute a Jewish interlocutor raising objections and drawing false inferences about his gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul also implores the Romans to pray that he might be delivered from the unbelievers in Judea. The revival of militancy and nationalistic fervour among fellow Jews and the rise of fanatics who believed that Jews who fraternized with Gentiles were traitors presented serious dangers. Dunn writes, ‘Such nationalistic feeling would tend to view the offering of Gentiles with increased suspicion’ (Dunn, II, p. 880). He cites Josephus’s account that the later Jewish revolt against Rome became inevitable when the firebrand captain of the temple, Eleazar, son of the high priest Ananias, persuaded the temple officials to ‘accept no further gift or sacrifice from a foreigner’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("J.W.")]), _vm._v(" 2.409–410 [Thackeray, LCL]). The believers in Jerusalem might be intimidated by a radical element of non-believers and fear accepting anything from uncircumcised Gentiles.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul must also explain why he is postponing his visit to Rome. Some might wonder why an apostle to the Gentiles continues to bother with the Jews in Jerusalem. Wiefel documents that strong anti-Jewish sentiments existed in Rome at the time of Nero and before, and reasonably contends that ‘the positive statements regarding all of Israel appear for the first time in Paul’s letter to the Romans and must be seen against this background’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-010"
    }
  }, [_vm._v("63")])])]), _vm._v(" Paul informs the Romans that a ‘hardness’ has overtaken the Jews, but it is not final (11:2). His deep belief that God has not given up on Israel means that neither will he give up on his ‘kindred according to the flesh’ (9:3). Paul’s return to Jerusalem is not love’s labour lost that squanders more promising evangelistic opportunities in the West. Paul believes that it is futile to go to Rome or Spain with a gospel of reconciliation while leaving behind an unreconciled church in which Jews and Gentiles refuse to accept one another. He is convinced that the salvation of Jews and the salvation of Gentiles are intertwined (11:25–32). Since Israel’s stumbling has meant ‘riches’ and ‘reconciliation’ for the world, how much more will their acceptance of the gospel bring for the world (11:12, 15)!")]), _vm._v(" "), _c('h2', {
    staticClass: "chd"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("iv. Giving the Romans Paul’s gospel so that they might proclaim it themselves")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jervis contends that Paul writes Romans out of his apostolic obligation to them so that they ‘may hear his particularly powerful and effective presentation of the gospel’ and ‘become part of his “offering” of “sanctified” and “obedient” Gentiles’ to God."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-009"
    }
  }, [_vm._v("64")])])]), _vm._v(" The letter, then, serves as a preliminary sharing with them of his ‘spiritual gift to strengthen’ them (1:11), but to strengthen them in what way? Since his recipients are already believers, he is not writing to add them to his harvest of Gentiles. Paul instead wants in this lengthy letter to brace up theologically their understanding of and witness to the gospel, which he self-assuredly identifies as ‘my gospel’ (2:16; 16:25).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Reichert proposes that Paul instructs the recipients of the letter in his gospel to enable them to proclaim it on their own should his plans fall through and his coming to Rome continue to be thwarted. The letter is therefore a ‘balancing act’. The Romans are not simply the recipients of his gospel (2:16; 16:25) but also those who are to broadcast his gospel."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-008"
    }
  }, [_vm._v("65")])])]), _vm._v(" On the one hand, since they have Paul’s gospel in this letter, they should be able to fend off interlopers ‘who cause dissensions and offences’ (16:17–20; cf. 2 Pet. 2:1; 2 John 7), the legalists who would amend it, the libertines who would pervert it, and the hot-air merchants who would twist it to glorify themselves. On the other hand, they share a calling from God (1:1, 6–7) that imposes the obligation to preach the gospel to others who remain in bondage to sin."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-007"
    }
  }, [_vm._v("66")])])]), _vm._v(" They have in Paul’s gospel a theological wellspring from which to evangelize others, both Jew and Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Melanchthon’s oft-quoted pronouncement that the letter is ‘the compendium of Christian doctrine’ "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-006"
    }
  }, [_vm._v("67")])])]), _vm._v(" is unsatisfactory because Paul does not touch on or deal systematically with many vital Christian doctrines. The arguments in this letter, however, draw on Paul’s long experience as a teacher and preacher, and they lay out central facets of his gospel that are the theological foundation for bringing Jews and Gentiles to the obedience of faith, for helping them recognize their solidarity in Christ and how it is part of God’s purpose to bring wholeness and order through Christ to a disordered and broken world. Sympathetic mutuality should emerge from the recognition that Jews and Gentiles are one in Christ. It expresses Paul’s missionary vision for all churches everywhere, not just Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This focus also explains the lengthy ethical section. While it may ‘provide examples of the kind of concrete moral behavior expected of Christians’,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-005"
    }
  }, [_vm._v("68")])])]), _vm._v(" most importantly, it teaches how Christians are to live in a pagan society and how they as a diverse body of believers are to handle in-house differences. It diminishes the effect of Romans to read it as if it were addressed only to a particular church with a particular problem. ‘The gospel of God’ (1:1) that Paul presents in this letter is intended to bring about the obedience of faith for the entire world, including the Romans ‘who are called to belong to Jesus Christ’ (1:6). It ‘is directed to the human problem and therefore includes all local problems’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-004"
    }
  }, [_vm._v("69")])])]), _vm._v(" For humans who are religiously wired and prone to quarrel, Paul’s admonitions in 14:1 – 15:13 present a model of Christian reconciliation that assumes that the community’s life must reflect the reconciliation worked by God in the lives of believers. Since God has saved Gentiles and adopted them into the people of God on the same grounds as Jews, through faith in Christ, Jews and Gentiles must accept one another and live together in harmony. This truth also applies to any Christian group that might divide over indifferent matters. An unreconciled church impedes the preaching of the gospel of reconciliation.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Mindful of the tensions and misinterpretations his gospel has provoked and fully aware that he will have to defend it when he arrives in Jerusalem, Paul fully expounds his gospel for the Roman believers. His hope is that they might affirm its universal scope, live in harmony with one another, walk according to the Spirit, and share in his commitment to bring about ‘the obedience of faith’ among the Gentiles in every nation for the glory of God (16:25–27) by sending him on to proclaim the gospel in Spain.")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd",
    attrs: {
      "id": "rch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5. The nature of the letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Richards notes that the average length of over 14,000 private papyrus letters that have been discovered is eighty-seven words. Aside from Romans, Paul’s letters average around 2,495 words. That far exceeds the average number of words in the epistles of the notable literary letter writers Cicero and Seneca. Cicero’s letters averaged 295 words, with his longest letter consisting of 2,520 words. Seneca averaged 972 words, with his longest letter ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")]), _vm._v(" 95) consisting of 4,201 words. The 7,114 words in Paul’s letter to the Romans make it exceptional. Richards estimates the cost for producing such a long letter to be equivalent to $2,275."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-003-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-003"
    }
  }, [_vm._v("70")])])]), _vm._v(" Paul was not a frequent letter writer, but his outsized letters were intended to reach a wide audience since they were not written to one recipient but were addressed to a community of believers, including Philemon (Phlm. 2).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul shaped the letter form to serve his own purposes, but the various theories attempting to identify the genre and rhetorical categorizations of the letter have not reached a consensus."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-002"
    }
  }, [_vm._v("71")])])]), _vm._v(" These differing conclusions suggest that Romans cannot be pressed into any one particular genre, and ‘these resemblances mean nothing more than that Paul has effectively utilized various literary conventions of his culture to get his message across’ (Moo, p. 14). The assumption that Paul received a formal rhetorical education is uncertain. Schellenberg finds no evidence that Paul ‘evinces familiarity with the specific conventions of formal Greco-Roman rhetoric’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-001"
    }
  }, [_vm._v("72")])])]), _vm._v(" Romans may simply be described as a very long ‘letter–essay’ containing ‘instructional material set out within an epistolary frame’ (Longenecker, p. 14).")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd",
    attrs: {
      "id": "rch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6. Theological themes in Romans")])])]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("a. God")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The frequency of Paul’s references to God ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("theos")]), _vm._v(") in the letter, 153 times, reveals that it is ‘fundamentally about God’ (Morris, p. 20), but more precisely, about God’s power through Jesus Christ to save humanity from destruction (1:3–4, 16–17). Paul asserts that God is ‘one’ (3:30), ‘immortal’ (1:23), ‘eternal’ (16:26), and with unfathomable knowledge and wisdom (11:33; 16:27). God is the God of both Jews and Gentiles (3:29), and ‘from him and through him and to him are all things’ (11:36). Paul does not simply identify God by God’s attributes. God is best and most fully known from what God has done in Christ. The gospel of God (1:1) is the power of God for salvation (1:16), and it is God’s power alone that saves humans (11:23). The gospel reveals the righteousness of God (1:17): God’s saving action on behalf of his people that is unleashed on the world, God’s justice in inflicting wrath and judging the world (3:3–6), and God’s gift to humans in declaring those who have faith to be righteous (4:3–11, 22–25; 5:17; 8:33). God is faithful and can do, and does, all that he has promised (4:21; 11:29), and God’s sovereign will cannot be prevented from being accomplished (9:11–24) so that all things will accrue to God’s glory (11:36; 16:27).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("While the righteousness of God brings salvation without distinction to all who believe (3:21–25, 29–30; 14:3, 18), the wrath of God’s righteous judgment on sinful humanity is made plain in history (1:18–31) and will be meted out at the end of time when all will stand before God’s judgment seat (2:1, 5; 3:4–6; 9:22; 12:19; 14:10). God impartially condemns (2:11) all who wickedly oppose his will. Yet God is kind and forbearing (2:4). God saves believers from the wrath that is due to sinful humankind (5:9) because God is merciful (9:16; 11:30; 15:9) and justifies the ungodly (8:33). God’s wrath and God’s mercy are not in opposition to each other but are interdependent (Isa. 60:10).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The God of Israel also shows grace to Gentiles and intends to include them in the people of God based on their confession of faith, not their Jewish ancestry or conversion that comprises undergoing Jewish rites of passage. Since the law was not intended to bring salvation, God reckons humans to be righteous apart from works (4:6). Justification by faith is the theological counterpart to Jesus’ pronouncements in the Gospels that a person’s sins are forgiven (Matt. 9:2; Mark 2:5; Luke 7:47–48). Jews also need the gospel of grace. It is only by God’s grace (5:15, 20) that God cancels the wages of sin and freely offers the gift of eternal life (6:23). In doing so, ‘God has done what the law, weakened by the flesh, could not do: by sending his own Son in the likeness of sinful flesh, and to deal with sin, he condemned sin in the flesh’ (8:3). God has put forward Christ as a sacrifice of atonement by his blood to save Christ-followers who have faith in what God has done (3:25). God gives life to the dead and calls into existence the things that do not exist (4:17) and raised Christ from the dead (4:24; 10:9). God loves us and ‘proves his love for us in that while we still were sinners Christ died for us’ (5:8). Believers are beloved of God (1:7) and as God’s children can intimately address God as ‘Abba! Father!’ (8:15). Nothing can separate believers from God’s love (8:35–39), whether they be supernatural powers that God rules or the earthly powers that God has appointed (13:1), because God has predestined believers to be glorified with Christ (8:29–30).")]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("b. Jesus Messiah")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Paul utters a cry of desperation, ‘W"), _c('span', {
    staticClass: "ind"
  }, [_vm._v("retched man that I am! Who will rescue me from this body of death?’ (7:24). This cry raises the issue: h")]), _vm._v("ow do humans living in a world of chaos, under God’s wrath and under the tyranny of sin, death (5:12–21) and the law, which human sin corrupts (7:7–25), enter a right relationship with God? "), _c('span', {
    staticClass: "ind"
  }, [_vm._v("He asks ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("who")]), _c('span', {
    staticClass: "ind"
  }, [_vm._v(" will deliver him, not ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _c('span', {
    staticClass: "ind"
  }, [_vm._v(" will deliver him, and the answer comes in the next verse: ‘Thanks be to God through Jesus Christ our Lord!’ (7:25; cf. 11:26).")]), _vm._v(" Paul identifies Christ as the Son of God (1:3, 4, 9; 5:10; 8:3, 29, 32), and in 9:5 goes much further. He is the Messiah according to the flesh, but more: he is God over all (see commentary). He has died and been raised by God to live again so that he might be Lord of both the dead and the living (14:9).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Paul emphasizes that the abundance of grace in which believers stand (5:17) comes from Christ’s act of obedience in "), _c('span', {
    staticClass: "ind"
  }, [_vm._v("dying for the ungodly (5:6) and sinners (5:8). It leads to ")]), _vm._v("the possibility that many will be made righteous. Christ’s atoning death countered Adam’s trespass that led to the plight of death and condemnation that burdens all humanity (5:12–21). Through Christ, believers receive ‘redemption’ (3:24) and have ‘peace with’ God (5:1) and receive ‘reconciliation’ (5:11). In Christ, they are "), _c('span', {
    staticClass: "ind"
  }, [_vm._v("set free from the law of sin and of death and no longer stand condemned (8:1–2). ")]), _vm._v("Christ Jesus has not left them to fend for themselves but is at the right hand of God interceding for them (8:34). "), _c('span', {
    staticClass: "ind"
  }, [_vm._v("In Christ, they ‘walk in newness of life’ (6:4). It is the great hope of believers that they will be raised with Christ from death (6:5–9; 8:11) and ")]), _vm._v("conformed to the image of God’s Son. Through Christ Jesus, "), _c('span', {
    staticClass: "ind"
  }, [_vm._v("they will ")]), _vm._v("receive the gift of eternal life (5:21; 6:22–23).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "ind"
  }, [_vm._v("G")]), _vm._v("race and peace become the keynotes for those who live under Christ’s lordship in the new age of salvation (1:7; 8:6; 14:19; 15:13). Consequently, those welcomed by God in Christ are to pursue peace with other believers (14:19) and, as far as possible, to live peaceably with all (12:18). The grace and peace that come through Christ have made possible the universal, impartial reach of salvation to both Jews and Gentiles. Gentiles who believe in the gospel (1:5–6; 4:16–18; 9:24, 30; 10:12–13; 11:11, 25; 15:7–18; 16:26) have been incorporated into God’s people, but Paul insists that they do not displace Israel. While Israel according to the flesh does not constitute the true people of God (9:6) and has been cut down to a remnant (9:27–29; 11:5), God has a grander purpose to save a full number of Israel (11:26). Despite appearances to the contrary, mainstream Israel’s present faithlessness in rejecting the gospel will not nullify God’s faithfulness (3:3).")]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("c. The Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘The Spirit’ figures prominently in the letter. Paul refers to ‘the Spirit’ fifteen times (2:29, cf. "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("CSB")]), _vm._v("; 7:6; 8:4, 5, 6, 9, 13, 14, 16, 23, 26, 27 [2x]; 15:19, 30), ‘the Holy Spirit’ five times (5:5; 9:1; 14:17; 15:13, 16) and ‘the spirit of holiness’ once (1:4). He also uses the terms ‘the Spirit of God’ (8:9, 11 [2x], 14) and the ‘Spirit of Christ’ (8:9). Paul states that Christ ‘was declared to be Son of God with power according to the spirit of holiness by resurrection from the dead’ (1:4). The Spirit creates true circumcision of the heart (2:29) because the written code only kills. Where the law brings death, the Spirit gives life (7:6; cf. 2 Cor. 3:6). The Spirit continuously pours God’s love into believers’ hearts (5:5) and sets them free from the law of sin and death (8:2).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The same Spirit at work in the resurrection of Jesus Christ from the dead (1:4) is at work here and now to make the newness of the resurrected life a reality in the lives of believers. Living under the power of the Spirit enables Christ-followers to fulfil the just requirement of the law (8:4) and to put to death the deeds of the body (8:13). The mind that is sold into sin’s slavery in the everyday marketplace of the flesh is transformed by the Spirit and brings life and peace (8:5–8). The Spirit does not simply convey the mysteries of the Spirit (1 Cor. 14:2) but also enlightens and renews the darkened, reprobate mind that fosters indecent behaviour (1:28), and directs believers to live ethical lives that are well pleasing to God (12:2). The mind that is set on the things of the Spirit and led by the Spirit is no longer hostile to and alienated from God (8:7). When the Spirit of God dwells in a believer the result is a healthy, intimate relationship with God (8:9) and a wholesome relationship with others (cf. Gal. 5:19–24).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Spirit as ‘the spirit of adoption’ affirms that believers are the children of God (8:15–16), intercedes for them in their creaturely weakness"), _c('span', {
    staticClass: "bold"
  }), _vm._v("in communicating to God when they do not know what to pray in times of suffering (8:26–27), and, consequently, inspires their hope (15:13). Believers’ experience of the first fruits of the Spirit (8:23) anticipates the full blessings that will come at the end of the age. Believers aglow in the Spirit (12:11) and filled with the Spirit’s love (15:30) convey the joy (14:17) that wins others to Christ. The Spirit also gave power to Paul’s ministry through the signs and wonders that accompanied his proclaiming the good news of Christ (15:19).")]), _vm._v(" "), _c('h2', {
    staticClass: "bhd"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("d. Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Scriptures of Israel are authoritative for Paul as the word of God, and more than half of the scriptural quotations in Paul’s letters are to be found in Romans. They are a witness to the gospel (1:2; 3:21; 4:23–24a; 15:3–4, 8–9; 16:26) and reveal that God’s promises to Israel are fulfilled in Christ (4:13–17; 9:4–5; 15:8). Consequently, Paul ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reads the Old Testament christologically approaching it with the question of how it bears witness to the Christ event")]), _vm._v("’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-000"
    }
  }, [_vm._v("73")])])]), _vm._v(" The crucified and risen Messiah becomes the foundation of a new perspective on the law and the key for unveiling the mystery of God’s plan in Scripture to save both Jews and Gentiles that heretofore was not fully recognized or understood. The Old Testament remains relevant for Christians who understand that it ‘was written for our instruction, so that by steadfastness and by the encouragement of the scriptures we might have hope’ (15:4; cf. 4:23–24).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Throughout Romans Paul cites the Scriptures to show how the gospel, as compared with the law, contends with the weakness of the flesh, the plague of sin and the power of death. He clinches his case that no one on earth, including Jews, is righteous (3:10 = Eccl. 7:20) and that all humankind is in bondage to sin (1:18 – 3:10) with a cluster of texts from the Psalms and the Prophets (3:11–18). His argument that Abraham was justified by faith and not works and that he is the father of all who believe (4:1–25) is based on his interpretation of Genesis 15:6 and Psalm 32:1–2. Paul draws on Genesis 3 to compare Adam, ‘a type of the one who was to come’ (5:14), to Christ to illustrate that ‘just as sin exercised dominion in death, so grace might also exercise dominion through justification leading to eternal life through Jesus Christ our Lord’ (5:21). To cap his argument that the suffering of believers in a hostile world does not mean that God has abandoned them or that it negates God’s purpose to glorify them, Paul cites Psalm 44:22 (8:36). Though they may be led to the slaughter like sheep, they will be more than conquerors since nothing can separate them from the love of God in Christ (8:37–39). Paul cites Scripture at least forty times in chapters 9–11 to prove that Gentiles can be included in the people of God, that God remains faithful to Israel, and that the salvation of Gentiles and the salvation of Israel are interconnected. He wraps up this long argument by citing Job and Isaiah (11:33–36). In 15:9–12, Paul also concludes his exhortations of chapters 12–15 by citing texts from the Psalms, Deuteronomy and Isaiah – the Law, the Prophets and the Writings – to seal his argument that God has willed the inclusion of Gentiles in salvation so that they together with Jews ‘may with one voice glorify the God and Father of our Lord Jesus Christ’ (15:6).")]), _vm._v(" "), _c('hr', {
    staticClass: "rule"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-072"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-072-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("1.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Luther, ‘Prefaces to the New Testament’, p. 365.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-071"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-071-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("2.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Cf. Mitchell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heavenly Trumpet")]), _vm._v(", pp. 440–487.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-070"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-070-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("3.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Luther, ‘Latin Writings’, p. 337.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-069"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-069-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("4.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wedderburn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reasons")]), _vm._v(", p. 16.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-068"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-068-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("5.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Hurtado, ‘Doxology’, pp. 185–199, and Moo, p. 952 n. 341,"), _c('em', {
    staticClass: "italic"
  }), _c('span', {
    staticClass: "Emphasis CharOverride-1"
  }, [_vm._v("provide a technical discussion of the textual history of the passage and argue that it concluded the letter here")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-067"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-067-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("6.")])]), _c('span', {
    staticClass: "nl2"
  }), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bray, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(", pp. 379–380.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-066"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-066-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("7.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Gamble, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Textual History")]), _vm._v(", pp. 115–116.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-065"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-065-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("8.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("G 1739"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("mg")]), _vm._v(" 1908"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("mg")]), _vm._v(" it"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("g")]), _vm._v(" Origen. ‘In Rome’ is also omitted by G in 1:15, which is unlikely to have been accidental.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-064"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-064-backlink"
    }
  }, [_c('span', {
    staticClass: "nl2"
  }), _vm._v("9.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Luther, ‘Prefaces to the New Testament’, p. 380.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-063"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-063-backlink"
    }
  }, [_vm._v("10.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Beker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul")]), _vm._v(", p. 77.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-062"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-062-backlink"
    }
  }, [_vm._v("11.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Jervis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Purpose")]), _vm._v(", pp. 14–28.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-061"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-061-backlink"
    }
  }, [_vm._v("12.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Dahl, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies")]), _vm._v(", p. 78.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-060"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-060-backlink"
    }
  }, [_vm._v("13.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Kettunen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abfassungszweck")]), _vm._v(", p. 50.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-059"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-059-backlink"
    }
  }, [_vm._v("14.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Byrskog, ‘Epistolography’, p. 38.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-058"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-058-backlink"
    }
  }, [_vm._v("15.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Haacker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology")]), _vm._v(", p. 17.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-057"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-057-backlink"
    }
  }, [_vm._v("16.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("DeSilva, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")]), _vm._v(", p. 602 n. 11; LSJ, p. 1408.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-056"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-056-backlink"
    }
  }, [_vm._v("17.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Donfried, ‘False Presuppositions’, p. 103.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-055"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-055-backlink"
    }
  }, [_vm._v("18.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wedderburn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reasons")]), _vm._v(", p. 54.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-054"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-054-backlink"
    }
  }, [_vm._v("19.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Bruce, ‘Romans Debate’, p. 181.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-053"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-053-backlink"
    }
  }, [_vm._v("20.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("For example, cf. Campbell, ‘Romans III’, p. 264.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-052"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-052-backlink"
    }
  }, [_vm._v("21.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Minear, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Obedience")]), _vm._v(", pp. 8–15. The first faction, the ‘weak in faith’ group, condemned the second, the ‘strong in faith’ group, who in turn ridiculed and despised the first group. Minear identifies the third group as ‘the doubters’. The fourth and fifth groups he sees as composed of ‘weak in faith’ and ‘strong in faith’, respectively, but distinguished from the first and second groups by the fact that they did not condemn or despise the others. In my view, this represents an overstrained parsing of the text.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-051"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-051-backlink"
    }
  }, [_vm._v("22.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Suetonius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Claud.")]), _vm._v(" 25.4. "), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Chrestus was a customary slave name, meaning ‘useful’ or ‘beneficial’, and since Christos, meaning ‘anointed’, might not have made sense as a name, it would have been an understandable mistake. It also was politically convenient to attribute the disruption to a slave. ")]), _vm._v("It is unlikely that he was a Jewish rabble-rouser since no evidence exists that Jews bore that name or that he was the one who persuaded Claudius to expel the Jews since the grammar does not support this reading. Tertullian belittles opponents of Christians who do not even know how to pronounce the name they purport to hate, pronouncing it ‘Chrestianus’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apol.")]), _vm._v(" 3.5). Tacitus correctly spelled his reference to Jesus as ‘Christus’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann.")]), _vm._v(" 15.44).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-050"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-050-backlink"
    }
  }, [_vm._v("23.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wiefel, ‘Jewish Community’, p. 96.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-049"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-049-backlink"
    }
  }, [_vm._v("24.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Barclay, ‘Is It Good News?’, p. 93.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-048"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-048-backlink"
    }
  }, [_vm._v("25.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Keener, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Acts")]), _vm._v(", pp. 2697–2698.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-047"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-047-backlink"
    }
  }, [_vm._v("26.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Ibid., pp. 2705–2711.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-046"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-046-backlink"
    }
  }, [_vm._v("27.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Ibid., p. 2704.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-045"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-045-backlink"
    }
  }, [_vm._v("28.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Lampe, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("From Paul to Valentinus")]), _vm._v(", p. 14.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-044"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-044-backlink"
    }
  }, [_vm._v("29.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Murphy-O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul")]), _vm._v(", p. 333; cf. pp. 9–15.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-043"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-043-backlink"
    }
  }, [_vm._v("30.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wedderburn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reasons")]), _vm._v(", p. 80.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-042"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-042-backlink"
    }
  }, [_vm._v("31.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wuellner, ‘Paul’s Rhetoric’, pp. 134, 139–140.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-041"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-041-backlink"
    }
  }, [_vm._v("32.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Kettunen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abfassungszweck")]), _vm._v(", pp. 152–154.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-040"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-040-backlink"
    }
  }, [_vm._v("33.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Meeks, ‘Judgment’, p. 292.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-039"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-039-backlink"
    }
  }, [_vm._v("34.")])]), _c('span', {
    staticClass: "nl2"
  }), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "de-DE"
    }
  }, [_vm._v("Hartwig and Theissen, ‘Die korinthische Gemeinde’, pp. 229–252.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-038"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-038-backlink"
    }
  }, [_vm._v("35.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Garland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1 Corinthians")]), _vm._v(", pp. 358–360.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-037"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-037-backlink"
    }
  }, [_vm._v("36.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Karris, ‘Romans 14:1 – 15:13’, pp. 73–75.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-036"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-036-backlink"
    }
  }, [_vm._v("37.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Furnish, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Love Command")]), _vm._v(", p. 115, contends, ‘Romans is addressed to a church of which Paul has no firsthand knowledge, and his discussion of “the strong” and “the weak” in 14:1 – 15:13 reads like a generalized adaptation of a position he had earlier worked out respecting an actual, known situation in Corinth.’")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-035"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-035-backlink"
    }
  }, [_vm._v("38.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Knox, ‘Galatians’, p. 343.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-034"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-034-backlink"
    }
  }, [_vm._v("39.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Zeller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Juden und Heiden")]), _vm._v(", pp. 38–77; Dewey, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EIS THN SPANIAN")]), _vm._v("’, pp. 321–349; and Morris, pp. 16–17.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-033"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-033-backlink"
    }
  }, [_vm._v("40.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Jewett cites Cicero, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quint. fratr")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(" 1.1.27; Livy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Rome")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("25.33.2; 27.17.10; 28.33.2–4; Florus 1.33–34; Caesar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bell. civ.")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("1.38.3; 1.44.2; and Pliny, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(" 8.24.4.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-032"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-032-backlink"
    }
  }, [_vm._v("41.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Strabo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geogr.")]), _vm._v(" 3.1.8; cf. 1.2.31; 2.5.14; 3.1.4.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-031"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-031-backlink"
    }
  }, [_vm._v("42.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("BDAG, p. 873. Cf. Acts 15:3; 1 Cor. 16:6, 11; 2 Cor. 1:16; Titus 3:13; 3 John 6; 1 Macc. 12:4.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-030"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-030-backlink"
    }
  }, [_vm._v("43.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Crafton, ‘Paul’s Rhetorical Vision’, p. 327.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-029"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-029-backlink"
    }
  }, [_vm._v("44.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Prior, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul the Letter-Writer")]), _vm._v(", p. 131.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-028"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-028-backlink"
    }
  }, [_vm._v("45.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Ibid., p. 135.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-027"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-027-backlink"
    }
  }, [_vm._v("46.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Bruce, ‘The Romans Debate’, pp. 187–188.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-026"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-026-backlink"
    }
  }, [_vm._v("47.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Longenecker and Still, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thinking through Paul")]), _vm._v(", p. 169.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-025"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-025-backlink"
    }
  }, [_vm._v("48.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wedderburn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reasons")]), _vm._v(", p. 5.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-024"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-024-backlink"
    }
  }, [_vm._v("49.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Holloway, ‘Rhetoric’, p. 114.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-023"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-023-backlink"
    }
  }, [_vm._v("50.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Since Paul never distinguishes persons in chapter 16 by their secular status, identifying Erastus as ‘the city treasurer’ would seem to be intended to heighten their regard for Paul.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-022"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-022-backlink"
    }
  }, [_vm._v("51.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Du Toit, ‘Persuasion’, p. 200.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-021"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-021-backlink"
    }
  }, [_vm._v("52.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Holloway, ‘Rhetoric’, p. 121.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-020"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-020-backlink"
    }
  }, [_vm._v("53.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Acts remains curiously silent about the collection except for a hint that Paul brought ‘alms’ to his nation (Acts 24:17).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-019"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-019-backlink"
    }
  }, [_vm._v("54.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Holloway, ‘Rhetoric’, p. 77.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-018"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-018-backlink"
    }
  }, [_vm._v("55.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Garland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("2 Corinthians")]), _vm._v(", pp. 418–419.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-017"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-017-backlink"
    }
  }, [_vm._v("56.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("The collection is not a type of temple tax (Matt. 17:24–27). Though Gentile Christians are indebted to the Jerusalem church for having shared their spiritual blessings (Rom. 15:27), paying a tax would only reinforce a Jewish supremacy over the Gentiles.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-016"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-016-backlink"
    }
  }, [_vm._v("57.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Paul uses the same word ‘acceptable’ ("), _c('span', {
    staticClass: "greek_roman CharOverride-4",
    attrs: {
      "lang": "el-GR"
    }
  }, [_vm._v("εὐπρόσδεκτος")]), _vm._v(") in 15:16 to describe the goal of his ‘priestly service of the gospel of God’ as a minister of Christ to the Gentiles that they might be an offering.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-015"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-015-backlink"
    }
  }, [_vm._v("58.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("A past famine prompted an earlier relief effort (Acts 11:28). Persecution (Gal. 1:22–23; 1 Thess. 2:14–15) probably deepened their poverty.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-014"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-014-backlink"
    }
  }, [_vm._v("59.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Cf. the many references to the inclusion of Gentiles (1:5–6, 13; 3:29; 4:16–18; 9:24, 30; 10:12–13; 11:11, 25; 15:7–18; 16:4, 26).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-013"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-013-backlink"
    }
  }, [_vm._v("60.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Jervell, ‘Letter’, pp. 58–59. Dahl, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies")]), _vm._v(", p. 77, writes, ‘It is easy to find reminiscences of the conflicts in which he had recently been involved and of which we have evidence in his letters to the Corinthian and Galatian Christians. It is also possible to read the letter as a draft of the “collection speech” which Paul intended to deliver in Jerusalem.’ Cf. also Wilckens, I, pp. 43–46.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-012"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-012-backlink"
    }
  }, [_vm._v("61.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Suggs, ‘Word’, p. 295.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-011"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-011-backlink"
    }
  }, [_vm._v("62.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Bornkamm, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul")]), _vm._v(", pp. 93, 95–96.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-010"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-010-backlink"
    }
  }, [_vm._v("63.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Wiefel, ‘Jewish Community’, p. 100.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-009"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-009-backlink"
    }
  }, [_vm._v("64.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Jervis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Purpose")]), _vm._v(", pp. 163–164.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-008"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-008-backlink"
    }
  }, [_vm._v("65.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Reichert, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Römerbrief")]), _vm._v(", pp. 77–91. Wedderburn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reasons")]), _vm._v(", p. 71, uses the balancing act image to a different end, referring to Romans as ‘a diplomatic tightrope’.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-007"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-007-backlink"
    }
  }, [_vm._v("66.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Schnabel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Early Church")]), _vm._v(", p. 1472.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-006"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-006-backlink"
    }
  }, [_vm._v("67.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Melanchthon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Loci Communes")]), _vm._v(", p. 69.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-005"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-005-backlink"
    }
  }, [_vm._v("68.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Aune, ‘Romans’, p. 296.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-004"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-004-backlink"
    }
  }, [_vm._v("69.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Martin, ‘Kerygma’, p. 303.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-003"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-003-backlink"
    }
  }, [_vm._v("70.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Richards, ‘Letter’, pp. 87–89.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-002"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-002-backlink"
    }
  }, [_vm._v("71.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("The multiple proposals concerning the character of Paul’s rhetoric in Romans reveal that judgments about it are not conclusive.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-001"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-001-backlink"
    }
  }, [_vm._v("72.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Schellenberg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rethinking")]), _vm._v(", p. 240.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-000"
    }
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', {
    staticClass: "fnot_num CharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Text/TNTC_Romans7#footnote-000-backlink"
    }
  }, [_vm._v("73.")])]), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Schnelle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apostle Paul")]), _vm._v(", p. 323 (emphasis original).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4acd6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TNTC_Romans7.vue
// module id = 78
// module chunks = 0